import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.handleKeydown)
    this.unlockScroll()
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("is-open")

    if (this.menuTarget.classList.contains("is-open")) {
      document.addEventListener("click", this.closeOnClickOutside)
      document.addEventListener("keydown", this.handleKeydown)
      this.lockScroll()
      this.syncAriaExpanded(true)
      // Focus first menu item
      const firstItem = this.menuTarget.querySelector("[role=menuitem], a, button")
      if (firstItem) firstItem.focus()
    } else {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.remove("is-open")
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.handleKeydown)
    this.unlockScroll()
    this.syncAriaExpanded(false)
  }

  closeOnClickOutside(event) {
    // Close if clicking outside the controller element
    if (!this.element.contains(event.target)) {
      this.close()
      return
    }
    // Close if clicking on the menu backdrop (mobile bottom sheet ::before)
    if (event.target === this.menuTarget) {
      this.close()
    }
  }

  lockScroll() {
    if (window.innerWidth < 768) {
      document.body.style.overflow = "hidden"
    }
  }

  unlockScroll() {
    document.body.style.overflow = ""
  }

  syncAriaExpanded(open) {
    const trigger = this.element.querySelector("[aria-expanded]")
    if (trigger) trigger.setAttribute("aria-expanded", String(open))
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
      // Return focus to trigger button
      const trigger = this.element.querySelector("[data-action*='dropdown#toggle']")
      if (trigger) trigger.focus()
      return
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      const items = [...this.menuTarget.querySelectorAll("[role=menuitem], a, button")]
      if (!items.length) return

      const current = document.activeElement
      const index = items.indexOf(current)

      if (event.key === "ArrowDown") {
        const next = index < items.length - 1 ? index + 1 : 0
        items[next].focus()
      } else {
        const prev = index > 0 ? index - 1 : items.length - 1
        items[prev].focus()
      }
    }

    // Tab trap: keep focus within the menu
    if (event.key === "Tab") {
      const items = [...this.menuTarget.querySelectorAll("[role=menuitem], a, button")]
      if (!items.length) return

      const first = items[0]
      const last = items[items.length - 1]

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
  }
}
